export const TERMS_PDF_URL = 'https://zoolife.tv/terms-and-conditions';
export const PRIVACY_PDF_URL = 'https://zoolife.tv/privacy-policy';
